import $ from 'jquery'

// Defaults for every datepicker (bootstrap-datepicker), whether a form field
// or a filter. Left to choose, it opens above the field when the window has
// room there, blind to the fixed header, which on a phone then covers its
// month and arrows. Below the field it always fits, scrolled into view where
// the screen ends. On a touch screen the keyboard stays shut: it would take
// half the screen from the picker, and a date is tapped there anyway.
$.extend($.fn.datepicker.defaults, {
  orientation: 'bottom',
  disableTouchKeyboard: true
})

$(document).on('show', '[data-provide="datepicker"]', (event) => {
  const datepicker = $(event.target).data('datepicker')
  if (!datepicker) return

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  datepicker.picker[0].scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' })
})
